import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './components/alert/alert.component';
import { ModalComponent } from './components/modal/modal.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { SendSmsComponent } from './components/send-sms/send-sms.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { RouterModule } from '@angular/router';
import { SwitchPageComponent } from './components/switch-page/switch-page.component';
import { ChartWrapperComponent } from './components/chart-wrapper/chart-wrapper.component';
import { ViewModalComponent } from './components/view-modal/view-modal.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { TransactionLogsComponent } from './components/transaction-logs/transaction-logs.component';
import { DndDirective } from './directives/dnd.directive';
import { ChipsComponent } from './components/chips/chips.component';
import { SelectedWrapperComponent } from './components/selected-wrapper/selected-wrapper.component';
import { UploadDialogComponent } from './components/upload-dialog/upload-dialog.component';
import { UploadDocComponent } from './components/upload-doc/upload-doc.component';
import { ConfirmExitModalComponent } from './components/confirm-exit-modal/confirm-exit-modal.component';
import { FilterComponent } from './components/filter/filter.component';
import { ExportExcelComponent } from './components/export-excel/export-excel.component';
import { MetricsComponent } from './components/metrics/metrics.component';
import { SearchDropdownComponent } from './components/search-dropdown/search-dropdown.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { AuditRecordComponent } from './components/audit-record/audit-record.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { ImageModule } from 'primeng/image';
import { ChartKpiBarComponent } from './components/kpi/chart-kpi-bar/chart-kpi-bar.component';
import { ChartKpiPieComponent } from './components/kpi/chart-kpi-pie/chart-kpi-pie.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ChartKpiGaugeComponent } from './components/kpi/chart-kpi-gauge/chart-kpi-gauge.component';
import { ChartKpiLineComponent } from './components/kpi/chart-kpi-line/chart-kpi-line.component';
import { ChartKpiStackedColumnComponent } from './components/kpi/chart-kpi-stacked-column/chart-kpi-stacked-column.component';
import { CopyButtonComponent } from './components/copy-button/copy-button.component';
import { UploadDialogButtonComponent } from './components/upload-dialog-button/upload-dialog-button.component';

@NgModule({
  declarations: [
    ModalComponent,
    DeleteModalComponent,
    SendSmsComponent,
    PageTitleComponent,
    AlertComponent,
    SwitchPageComponent,
    ChartWrapperComponent,
    ViewModalComponent,
    TransactionLogsComponent,
    DndDirective,
    ChipsComponent,
    SelectedWrapperComponent,
    UploadDialogComponent,
    UploadDocComponent,
    ConfirmExitModalComponent,
    FilterComponent,
    ExportExcelComponent,
    MetricsComponent,
    SearchDropdownComponent,
    LoaderComponent,
    MultiSelectDropdownComponent,
    AuditRecordComponent,
    StepperComponent,
    ConfirmModalComponent,
    ChartKpiBarComponent, 
    ChartKpiPieComponent,
    ChartKpiGaugeComponent, 
    ChartKpiLineComponent,
    UploadDialogButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxDocViewerModule,
    NgSelectModule,
    ImageModule,
    HighchartsChartModule,
    ChartKpiStackedColumnComponent,
    CopyButtonComponent
  ],
  exports: [
    DeleteModalComponent,
    SendSmsComponent,
    PageTitleComponent,
    AlertComponent,
    SwitchPageComponent,
    ChartWrapperComponent,
    ViewModalComponent,
    TransactionLogsComponent,
    DndDirective,
    ChipsComponent,
    SelectedWrapperComponent,
    UploadDialogComponent,
    UploadDocComponent,
    ConfirmExitModalComponent,
    FilterComponent,
    ExportExcelComponent,
    MetricsComponent,
    SearchDropdownComponent,
    LoaderComponent,
    MultiSelectDropdownComponent,
    AuditRecordComponent,
    StepperComponent,
    ConfirmModalComponent,
    ChartKpiBarComponent, 
    ChartKpiPieComponent,
    ChartKpiGaugeComponent, 
    ChartKpiLineComponent,
    ChartKpiStackedColumnComponent,
    UploadDialogButtonComponent
  ],
})
export class SharedModule {}
